module.exports = __webpack_public_path__ + "img/filigrana-2.fd2bce8a.png";